import useNarrowPane from '../../../../../../../../hooks/useNarrowPane';
import { positionStyle } from '../../../../positionStyle';
import React, { useRef, useMemo } from 'react';
import groupBy from 'lodash/groupBy';
import flatten from 'lodash/flatten';
import { isMobile } from 'react-device-detect';
import {
  useDroppable,
  useDraggable,
  useDndMonitor,
} from '@dnd-kit/core';

import { useDispatch, useSelector } from 'react-redux';
import {
  teamSelectPlayerOnGameField,
  setSelectedTeamIds,
  showMobileSidebarSection,
  teamReplacePlayerFromTheirPosition,
  setFormationListFilter,
  pitchPlayerPosition,
} from '../../../../../../../../redux/actions/Team';
import {
  selectedPlayerPosition,
  getPlayersForCurrentPosition,
  getTeamKit,
} from '../../../../../../../../redux/selector/Team';

import { showPopupWindow } from '../../../../../../../../redux/actions/Popups';
import { getPlayerInformation } from '../../../../../../../../redux/actions/League';
import PlayerCard from '../PlayerCard';
import { generalTeamRool } from '../../data';

import {
  POPUPS,
  ratingRangeStatus,
} from '../../../../../../../../service/constants';
import {
  simplifiedPosition,
  playerEffectivenessIndicators,
} from '../../../../../../../../service/data';
import { StyledHome } from '../../styled';
import { ReactComponent as DragIcon } from '../../../../../../../../assets/img/drag-icon.svg';

import { StyledPlayerDragIcon } from './styled';

  function Droppable(props) {
    const { team, teamView, narrow, isDragging, showPositionEffectiveness, teamKitData, activeDraggingId } = props;
    const { isOver, setNodeRef, active } = useDroppable({
      id: `${props.id}`,
    });
    const {
      name,
      firstName,
      lastName,
      ratingRange,
      potentialRange,
      formRange,
      yellowCards,
      suspension,
      playerPos,
      selectedCard,
      cardId,
    } = props;
    const drag = useDraggable({id: cardId || `empty-${props.id}`, disabled: !cardId || narrow || teamView !== 'myTeam'});
    const style = {
      background:
        isDragging && active
          ? showPositionEffectiveness(props.id, active.id)
          : undefined,
      padding: '1px 4px',
      borderTopLeftRadius: '6px',
      borderTopRightRadius: '6px',
      boxShadow: `${isOver ? '0 0 5px 3px rgb(0 0 0 / 15%)' : 'none'}`,
    };

    return (
      <div ref={node => {setNodeRef(node);drag.setNodeRef?.(node);}}
        {...drag.attributes} {...drag.listeners}
        onDragStart={event => event.preventDefault()}
        style={{touchAction: narrow ? 'auto' : 'none', cursor:cardId ? 'grab' : 'pointer',
        position: 'relative', borderRadius: 10,
        outline: isOver ? '3px solid var(--tol-header-accent, #00d99a)' : undefined,
        boxShadow: isOver ? '0 0 0 6px rgba(0, 0, 0, .35)' : undefined,
      }}>
        {isOver && active && (
          <div role="status" style={{
            position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
            background: '#102b25', color: '#fff', padding: '6px 10px', borderRadius: 6,
            font: '600 12px Archivo, sans-serif', whiteSpace: 'nowrap', zIndex: 5,
            pointerEvents: 'none',
          }}>
            {String(active.id).split(' ')[0] === cardId ? 'Keep position' : cardId
              ? `${team.some((p) => p._id === String(active.id).split(' ')[0]) ? 'Swap with' : 'Replace'} ${name || [firstName, lastName].filter(Boolean).join(' ')}`
              : `Move to ${simplifiedPosition[props.id] || props.id}`}
          </div>
        )}
        {!isMobile && <StyledPlayerDragIcon aria-hidden="true"><DragIcon/></StyledPlayerDragIcon>}

        <PlayerCard
          style={style}
          id={cardId}
          {...{
            name,
            firstName,
            lastName,
            ratingRange,
            potentialRange,
            formRange,
            yellowCards,
            suspension,
            playerPos,
            selectedCard,
            _id: cardId,
            teamKit: teamKitData,
          }}
        />
        {/*   </Draggable> */}
      </div>
    );
  }

export default function HomeTeam({
  team,
  strategy,
  activeDraggingId,
  teamView,
  fullPitch = false,
}) {
  const dispatch = useDispatch();
  const narrow = useNarrowPane();
  const teamPOSESSION = useRef(null);
  const playersList = useSelector(getPlayersForCurrentPosition);
  const playerPosition = useSelector(selectedPlayerPosition);
  const teamKitData = useSelector(getTeamKit);
  const [isDragging, startDragging] = React.useState(false);

  const selectedPlayer =
    playerPosition && playerPosition.replace(/[()]/g, '').toLowerCase();
  const teamField = useMemo(() => {
    if (strategy && generalTeamRool[strategy]) {
      teamPOSESSION.current = generalTeamRool[strategy];
      const MyTeam = groupBy(team, 'current_position');
      const newObjTeam = {};
      const keys = Object.keys(teamPOSESSION.current);
      keys.forEach((key) => {
        newObjTeam[key] = MyTeam[key]
          ? MyTeam[key]
          : teamPOSESSION.current[key];
      });
      return newObjTeam;
    }
    return [];
  }, [team, strategy]);

  React.useEffect(() => {
    const strategyTeamIds = flatten(Object.values(teamField)).map(
      (item) => item._id
    );
    dispatch(setSelectedTeamIds(strategyTeamIds));
  }, [strategy, team, teamField, dispatch]);
  const replaceFunction = (playerOnPitch, draggablePlayerId) => {
    if (isMobile) {
      if (playerOnPitch._id !== undefined) {
        dispatch(
          showPopupWindow(
            POPUPS.PLAYER_INFO_POPUP_VIEW,
            POPUPS.PLAYER_INFO_POPUP_VIEW,
            true
          )
        );
        dispatch(
          getPlayerInformation(playerOnPitch._id, POPUPS.PLAYER_INFO_POPUP_VIEW)
        );
      } else {
        dispatch(showMobileSidebarSection('list'));
      }
      dispatch(teamSelectPlayerOnGameField(playerOnPitch));
    } else {
      const playerFromSidebar = [...team, ...playersList].find(
        ({ _id }) => _id === draggablePlayerId.split(' ')[0]
      );
      if (!playerFromSidebar) return;
      // replace player from their position
      dispatch(teamSelectPlayerOnGameField(playerOnPitch));
      dispatch(teamReplacePlayerFromTheirPosition(playerFromSidebar));
    }
  };

  useDndMonitor({
    onDragStart() {
      startDragging(true);
    },
    onDragEnd({ active, over }) {
      if (!isMobile) {
        startDragging(false);
        if (over && teamField[over.id]?.[0]) {
          replaceFunction(
            {
              // TODO move selected dragging player data to local state
              ...teamField[over.id][0],
              current_position:
                teamField[over.id][0].current_position || over.id,
            },
            active.id.split(' ')[0]
          );
          if (!active.id.split(' ')[1]) {
            dispatch(setFormationListFilter('ALL'));
          }
          dispatch(pitchPlayerPosition(null));
        }
      }
    },
    onDragCancel() {
      startDragging(false);
    },
  });

  const showPositionEffectiveness = (dragPos, activePlayerId) => {
    const draggingPlayer = [...team, ...playersList].find(
      ({ _id }) => _id === activePlayerId.split(' ')[0]
    );

    return playerEffectivenessIndicators[draggingPlayer?.fav_position]?.[dragPos];
  };

  if (teamPOSESSION.current && strategy && generalTeamRool[strategy]) {
    return (
      <>
        {Object.keys(teamPOSESSION.current).map((playerPos, index) => {
          const playerData = teamField[playerPos][0];
          const {
            name,
            first_name: firstName,
            last_name: lastName,
            rating_range: range,
            form_range: formRange,
            current_position: currentPosition,
            fav_zone: favouriteZone,
            ...other
          } = playerData;
          const ratingRange = ratingRangeStatus[range];
          return (
            <StyledHome
              style={fullPitch ? positionStyle(playerPos, Object.keys(teamPOSESSION.current)) : { position: 'relative' }}
              onClick={
                isMobile && !fullPitch
                  ? () =>
                      replaceFunction({
                        ...other,
                        current_position: currentPosition || playerPos,
                        name,
                        _id: other._id,
                        firstName,
                        lastName,
                        rating: ratingRange,
                        selected: playerPos.replace(/[()]/g, '').toLowerCase(),
                      })
                  : undefined
              }
              key={playerPos}
              className={`home home-${
                currentPosition
                  ? currentPosition.replace(/[()]/g, '').toLowerCase()
                  : playerPos.replace(/[()]/g, '').toLowerCase()
              } strategy-${strategy}`}
            >
              <Droppable
                potentialRange={ratingRangeStatus[playerData.potential_range]}
                yellowCards={playerData.yellow_cards}
                suspension={playerData.suspension}
                narrow={narrow}
                team={team}
                teamView={teamView}
                isDragging={isDragging}
                showPositionEffectiveness={showPositionEffectiveness}
                teamKitData={teamKitData}
                activeDraggingId={activeDraggingId}
                id={playerPos}
                playerId={other._id}
                favouriteZone={favouriteZone}
                key={index}
                cardId={other._id}
                {...{
                  name,
                  firstName,
                  lastName,
                  ratingRange,
                  formRange,
                  playerPos,
                  selectedPlayer,
                  _id: other._id,
                }}
              />
            </StyledHome>
          );
        })}
      </>
    );
  }
  return <></>;
}
